// extracted by mini-css-extract-plugin
module.exports = {"resume":"index-module--resume--1I2km","subTitle":"index-module--subTitle--2GW7P"};